/**
 * The sizes and the fade every marker on a dispatch map shares, in pixels: `DispatchMap` draws
 * with them and `faceLayout` spaces faces by them, so the two can never disagree.
 */

/** A job pin, and the selected one (bigger and ringed, never recoloured). */
export const PIN_SIZE = 26;
export const PIN_SIZE_SELECTED = 34;
/** A person's face, and the picked one (larger, as the selected pin is). */
export const FACE_SIZE = 32;
export const FACE_SIZE_PICKED = 38;
/** How faint something the page is not talking about is drawn (the crew map's pick). */
export const DIM_OPACITY = 0.3;
